import React, { useState } from 'react'
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import Launch from '@material-ui/icons/Launch'
import { withStyles } from '@material-ui/core/styles'
import { ICON_BUTTON_ID, ROOT_CONTAINER_ID, EXPORT_OPTIONS } from '../../../../../../utils/graphUtils'

const styles = {
  button: {
    backgroundColor: '#E4E8F1',
    width: '120px',
    height: '40px',
    position: 'absolute',
    top: '-60px',
    right: '16px',
    letterSpacing: '2px'
  },
  menuItem: {
    fontFamily: 'National',
    fontSize: '15px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '22px'
  }
}

const ITEM_HEIGHT = 32
const paperProps = {
  style: {
    maxHeight: ITEM_HEIGHT * 4.5,
    width: 122
  }
}

const ExportBase = props => {
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleExport = ({ action }) => () => {
    const chart = document.querySelector(`#${ROOT_CONTAINER_ID}`)
    handleClose()
    action(chart)
  }

  const open = Boolean(anchorEl)
  const { classes } = props
  return (
    <Plugin name='Export'>
      <Template name='top'>
        <TemplatePlaceholder />
        <Button
          id={ICON_BUTTON_ID}
          variant='contained'
          color='default'
          className={classes.button}
          startIcon={<Launch />}
          onClick={handleClick}
        >
          Export
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={paperProps}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          {EXPORT_OPTIONS.map(option => (
            <MenuItem className={classes.menuItem} key={option.key} onClick={handleExport(option)}>
              {option.text}
            </MenuItem>
          ))}
        </Menu>
      </Template>
    </Plugin>
  )
}

export default withStyles(styles)(ExportBase)
